// THE HOME'S BUILD TAB — the app builder itself (functions/homeBuild.js; Nika
// 2026-10-23: "build tab should reuse ui/ux of /add-apps"). pages/main.js
// mounts it in the home's grid area as Build's view part; it holds the
// /add-app page (the build conversation, the build canvas, the person's apps),
// mounted on the tab's first show and kept from then on: a tab away puts it
// away, so a built app, a half-written ask and the canvas are where they were
// when the person comes back.
//
// IN PLACE (Nika 2026-10-23: "when switching to build transit page to canvas
// without switching the page or layout"): the route, the header and the tabs
// stay; only the main area changes, in the house crossfade of the home's views
// (the board's recipe, `C`, opacity only): closed it keeps no room — the mount
// lays it out of the flow like the other views, and it has no height — open it
// takes its band at once and fades in.
//
// THE BAND: the builder is a two-pane surface — the conversation and the
// canvas scroll inside their own panes — so it takes the viewport below its
// own top (`--home-build-top`, read by homeBuildFit) down to the shell's
// bottom gap (`--home-build-bottom`): `--nav-gap` (the global composer stands
// down here — the builder's own is the prompt, as on /add-app), `--slot-bottom`
// on a phone (the dock). The fallback before the first read is the usual top,
// `F`.
//
// ONE BUILDER AT A TIME (functions/homeBuild.js): a pane over the home that
// holds /add-app takes the builder — this one leaves the tree meanwhile and
// mounts again on the tab's next show.
//
// It holds no logic: every value comes from functions/homeBuild.js through
// `el.call`.
export const HomeBuildView = {
  tag: 'section',
  dataHomeBuild: true,
  ariaLabel: (el) => el.call('polyglot', 'workspace.homeView.build'),
  dataOpen: (el, s) => (el.call('homeBuildShown', s.root) ? 'true' : 'false'),
  ariaHidden: (el, s) => (el.call('homeBuildShown', s.root) ? null : 'true'),
  flow: 'y',
  width: '100%',
  minWidth: '0',
  boxSizing: 'border-box',
  '--home-build-bottom': 'var(--nav-gap)',
  '@mobileL': { '--home-build-bottom': 'var(--slot-bottom)' },

  // closed: no room, nothing to see, nothing to reach
  height: '0',
  overflow: 'hidden',
  opacity: '0',
  visibility: 'hidden',
  pointerEvents: 'none',
  transition: 'opacity C defaultBezier, visibility 0s linear C',
  '&[data-open="true"]': {
    height: 'calc(100dvh - var(--home-build-top, var(--spacing-F)) - var(--home-build-bottom))',
    minHeight: 'G',
    overflow: 'visible',
    opacity: '1',
    visibility: 'visible',
    pointerEvents: 'auto',
    transition: 'opacity C defaultBezier, visibility 0s linear 0s'
  },

  // While the builder's chunk loads: the house page skeleton (the lazy page's
  // own placeholder); homeBuildMount sets the page over it.
  content: { extends: 'PageSkeleton' },

  // The first show mounts the builder; every show reads the band. The view
  // opens in the same update, so both run a microtask later, once it has. A
  // pane that takes the builder unmounts this one.
  stateDeps: [
    (el, s) => !!el.call('homeBuildShown', s.root),
    (el, s) => !!el.call('homeBuildInPane', s.root)
  ],
  onStateUpdate: (el, s, ctx, change) => {
    const next = (change && change.next) || []
    if (next[1]) {
      el.call('homeBuildUnmount', el)
      return
    }
    if (!next[0]) return
    queueMicrotask(() => {
      el.call('homeBuildFit', el)
      el.call('homeBuildMount', el)
    })
  },
  onRender: (el, s) => {
    if (!el.call('homeBuildShown', s.root)) return
    queueMicrotask(() => {
      el.call('homeBuildFit', el)
      el.call('homeBuildMount', el)
    })
  },
  onWindowResize: (e, el) => el.call('homeBuildFit', el)
}
